import { Injectable } from '@angular/core';
import { UUID } from './uuid.entity';

@Injectable()
export class UuidService {
  public factory(separator?: string) {
    return new UUID(separator);
  }
}



// WEBPACK FOOTER //
// ./src/app/global/uuid.service.ts